import React, {Component} from 'react';
import {Input, Form} from "antd";
import {Scrollbars} from "react-custom-scrollbars";
import BaseTable from "../../../components/baseTable/BaseTable";
import BaseComponent from "../../../../base/BaseComponent";

class TaskReporter extends BaseComponent {
    static defaultProps = {
        show: true,
    };
    constructor(props) {
        super(props);
        this.state = {
            title: props.itemValue || "",
        }
    }

    componentDidMount() {
    }


    render() {
        return (
            <div id={'taskReporter'}>
                <Form.Item label={this.props.label} labelCol={{span: 3}} style={{display: 'flex'}}>
                    {this.renderReporterList()}
                </Form.Item>
            </div>

        );
    }

    renderReporterList = () => {
        let {itemValue} = this.props;
        if (!(itemValue&&itemValue.length > 0)) {
            return ""
        }
        let columns = [
            {
                title: '记者姓名',
                dataIndex: 'reporter.name',
                width:120,
                ellipsis:true,
                render: (text, record) => {
                    return text
                }
            },
            {
                title: '部门',
                width:150,
                dataIndex: 'reporter.currentDept.name',
                render:(text,record)=>{
                    return(
                        <div style={{width: '115px',overflow: 'hidden',textOverflow: 'ellipsis',whiteSpace:'nowrap'}}>{text}</div>
                    )
                }
            },
            {
                title: '类别',
                width:280,
                ellipsis:true,
                dataIndex: 'taskRole',
                render: (text, record) => {
                    return (
                        <div style={{display: "flex"}}>
                            {
                                text.map((item, index) => {
                                    return (
                                        <div
                                            key={index}
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                width: 72,
                                                height: 24,
                                                background: "#fff",
                                                borderWidth: "1px",
                                                borderStyle: "solid",
                                                borderColor: "#0050B3",
                                                borderRadius: 5,
                                                marginRight: 16,
                                                // cursor: "pointer",
                                                color: "#0050B3",
                                            }}>
                                            {item}
                                        </div>
                                    )
                                })


                            }
                        </div>
                    )
                }
            },
            {
                title: '领取状态',
                dataIndex: 'status',
                render: (text, record) => {
                 let  statusBackground = {
                        已提交: '#c7f',
                        进行中: '#c7f',
                        已完成: '#87d166',
                        未领取: '#f56c6c',
                        草稿: '#CC77FF'
                    };
                    return (
                        <div style={{display: 'flex', alignItems: 'center'}}>
                            <div style={{
                                background:statusBackground[text],
                                width: 8,
                                height: 8,
                                borderRadius: '50%',
                                marginRight: 10
                            }}></div>
                            {text}
                        </div>
                    )
                }
            },
        ];
        return (
            <div className={'reporterForm'}>
                <BaseTable columns={columns} dataSource={itemValue} style={{width:650}}/>
                <style>{`.reporterForm .ant-table-body{border:1px solid #e8e8e8}`}</style>
            </div>
        )
    };


}

export default TaskReporter